var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useEffect, useMemo, useRef, useState, useCallback } from '@max/max';
import View from '@hfe/max-view';
const isWeb = true;
const isMRN = false;
import { flattenStyle } from '@max/leez-style-util';
import MaxSensor from '@max/mbc-sensor';
import LIcon from '@max/leez-icon';
import Loading from './components/Loading/index';
import LinearGradient from '@hfe/max-linear-gradient';
import Tab from '@mcp/component-tab-component';
import { _toPx, getTabTheme, _remStyle } from './utils/style';
import { FixedPosition, ExtraIconType, TabStyle } from './types';
import { p2runit } from '@hfe/max-universal-unit-tool';
import TabExpand from './components/TabExpand';
import { throttle, uniqBy, debounce, isNumber } from 'lodash';
import { url, getTabMode, mc_bid, mv_bid, mv_com_bid, mc_com_bid } from './utils/constant';
import { getBaseStyle, getTheme } from './styles';
import './index.scss';
const MCModule = View;
const MCSection = View;
const MCSectionsModule = View;
const titleTextStyle = {
    fontWeight: 500,
    fontSize: _toPx(16),
    FontWeightType: 'medium'
};
// 获取tab项
const getTabItems = (tabList) => {
    const res = tabList === null || tabList === void 0 ? void 0 : tabList.map((i) => (Object.assign(Object.assign({}, i), { titleTextStyle: titleTextStyle, container: {
            width: 45
        } })));
    return res;
};
//获取初始tab项index和tabkey
const getRuntimeActiveIndex = (children, tabList, selectIndex) => {
    var _a;
    const index = isNumber(selectIndex) ? selectIndex - 1 : 0;
    if (children && children.length) {
        return {
            selectTabKey: (_a = tabList[index]) === null || _a === void 0 ? void 0 : _a.tabKey,
            defaultIndex: index
        };
    }
    const defaultIndex = (tabList === null || tabList === void 0 ? void 0 : tabList.findIndex((i) => i.tabKey === children.key)) || 0;
    return {
        defSelectTabKey: children.key,
        defaultIndex: defaultIndex
    };
};
const TabContainer = (props, ref) => {
    var _a, _b;
    const { isSubTab, _moduleId, children, tabList, tabStyle, tabLevel = 1, subLevelTabStyles = {}, linerExtraColor, fixedPosition = 'none', textActiveColor = '#FF4B10', headBgColorType = 'light', paddingStyles, loadingBgColorType = 'dark', tabPreload = false, anchor: stickyAnchorId = 'meishi-tab-container-sticky-anchorId', _renderElement, _uiInteractionAPI, _serverAPI, _eventInstance, _LXReport, _pageAPI = {}, _materialCustomGlobalVariables = {}, _updateMaterialCustomGlobalVariables = () => { }, isTabCenter } = props;
    const { enableScroll, disableScroll } = _pageAPI;
    //吸顶时背景色，文字固定为#FFFFFF
    const stickyWrapperBgColor = props.stickyWrapperBgColor || tabStyle === TabStyle.IMG ? props.stickyWrapperBgColor : headBgColorType === 'light' ? '#FFFFFF' : '#222222';
    //横滑/下拉：图片无下拉，文字吸顶固定下拉
    const extraIconType = tabStyle === TabStyle.IMG ? 'horizontal' : fixedPosition === 'none' ? props.extraIconType : 'vertical';
    const { bottomPaddingVal = 0, topMarginVal = 0, bottomMarginVal = 0 } = paddingStyles || {};
    const { mvReport, mcReport } = _LXReport || {};
    const { getModuleDSL = () => { } } = _serverAPI || {};
    const [tabContainerOpacity, setTabContainerOpacity] = useState(1);
    const tabWidth = 750;
    const isEdit = window && !!window.inEditor || false;
    //tab容器
    const wrapperRef = useRef(null);
    const wrapperHeight = useRef(0);
    //tab内容容器
    const contentRef = useRef(null);
    const contentHeight = useRef(0);
    const isTabVisible = useRef(false);
    const tabItemsMVReportFlag = useRef([]);
    const [isExtraTabOpen, setIsExtraTabOpen] = useState(false);
    const componentMvRef = useRef(false);
    const [activeIndex, setActiveIndex] = useState((_a = getRuntimeActiveIndex(children, tabList, props.selectTabKey)) === null || _a === void 0 ? void 0 : _a.defaultIndex);
    const [selectTabKey, setSelectTabKey] = useState((_b = getRuntimeActiveIndex(children, tabList, props.selectTabKey)) === null || _b === void 0 ? void 0 : _b.defSelectTabKey);
    const [tabItems, setTabItems] = useState(getTabItems(tabList));
    //是否正处于吸顶状态
    const [isSticky, setIsSticky] = useState(false);
    const [contentShow, setContentShow] = useState(true);
    //当前已吸顶的tab
    const stickyTabList = _materialCustomGlobalVariables['stickyTabList'] || [];
    //根据tab项个数和类型判断布局
    const mode = getTabMode(tabStyle, tabLevel, (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) || 0);
    // 通用tab默认高度，默认false
    const [stickyNavTopVal, setStickyNavTop] = useState(0);
    const [stickyTabTopVal, setStickTabTopVal] = useState(0);
    const stickyTopVal = useMemo(() => stickyNavTopVal + stickyTabTopVal, [stickyNavTopVal, stickyTabTopVal]);
    //是否有副标题
    const isDoubleLine = (tabItems === null || tabItems === void 0 ? void 0 : tabItems.some((i) => i.subtitle)) || false;
    //是否是吸顶tab
    const isStickyTab = fixedPosition === FixedPosition.STICKY;
    //是否需要横滑/下拉
    const showExtraIcon = mode === 'normal' && tabStyle === TabStyle.TEXT;
    //是否是下拉，吸顶tab默认下拉
    const isExtraIconV = showExtraIcon && (extraIconType === ExtraIconType.VERTICAL || isStickyTab);
    //是否有遮罩层
    const showMaskIcon = showExtraIcon && linerExtraColor;
    //根据背景色（浅色/深色）获取默认样式
    const { headBgColor, textDefaultColor } = useMemo(() => {
        return getTabTheme(headBgColorType);
    }, [headBgColorType]);
    // 通过theme修改文字Tab的样式 375设计稿
    const theme = useMemo(() => {
        return getTheme(textActiveColor, textDefaultColor, isDoubleLine, subLevelTabStyles, isSticky);
    }, [textActiveColor, textDefaultColor, isDoubleLine, subLevelTabStyles, isSticky]);
    //props变化更新所选tab项
    useEffect(() => {
        const { defSelectTabKey, defaultIndex } = getRuntimeActiveIndex(children, tabList, props.selectTabKey);
        if (defaultIndex !== activeIndex)
            setActiveIndex(defaultIndex);
        if (selectTabKey == defSelectTabKey)
            setSelectTabKey(defSelectTabKey);
    }, [children, tabList, props.selectTabKey]);
    //tab样式
    const styles = getBaseStyle({
        isSticky,
        tabStyle,
        tabWidth,
        isEdit,
        extraIconType,
        ExtraIconType,
        tabLevel,
        linerExtraColor,
        headBgColor,
        mode,
        isExtraIconV,
        showMaskIcon,
        stickyWrapperBgColor,
        extraWidth: isExtraIconV && !showMaskIcon ? 76 : 0,
        isStickyTab,
        isTabCenter
    });
    useEffect(() => {
        var _a;
        // 注册锚点
        console.log('注册锚点', _moduleId);
        (_a = _uiInteractionAPI === null || _uiInteractionAPI === void 0 ? void 0 : _uiInteractionAPI.anchor) === null || _a === void 0 ? void 0 : _a.addAnchor(`${stickyAnchorId}${_moduleId}`, _moduleId);
    }, [_moduleId, _uiInteractionAPI, stickyAnchorId]);
    useEffect(() => {
        setTabItems(getTabItems(tabList));
    }, [tabList]);
    useEffect(() => {
        //通用头部吸顶
        let count = 0;
        const timer = setInterval(() => {
            _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.emit('getNavBarStatus');
            count++;
            if (count >= 10) {
                setStickyNavTop(0);
                clearInterval(timer);
            }
        }, 100);
        const setNavTop = ({ immersive, height }) => {
            clearInterval(timer);
            const _height = immersive ? height : 0;
            setStickyNavTop(_height);
        };
        _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.on('broadcastNavBarStatus', setNavTop);
        return () => {
            _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.off('broadcastNavBarStatus', setNavTop);
        };
    }, [_eventInstance]);
    useEffect(() => {
        if (tabPreload) {
            tabItems.forEach((item, index) => {
                var _a;
                if ((_a = contentElements[index]) === null || _a === void 0 ? void 0 : _a.isLoading) {
                    setContentElements((preState) => {
                        const _contentElements = [...preState];
                        _contentElements[index] = {
                            element: <Loading _eventInstance={_eventInstance} loadingBgColorType={loadingBgColorType}/>,
                            isLoading: true
                        };
                        return _contentElements;
                    });
                    requestElement(index, item.tabKey);
                }
            });
        }
    }, [tabItems]);
    //tabStickyChange事件触发重新计算吸顶tab高度
    useEffect(() => {
        //计算当前吸顶tab所占高度
        const getSHeight = throttle((list) => {
            let tabStickyHeight = 0;
            for (let i of list === null || list === void 0 ? void 0 : list.sort((a, b) => a.index - b.index)) {
                if (i.tabKey === _moduleId) {
                    break;
                }
                tabStickyHeight += i.height || 0;
            }
            setStickTabTopVal(tabStickyHeight);
        }, 200);
        const getStickyTabHeight = function ({ list }) {
            getSHeight(list);
        };
        //tab吸顶
        _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.on('tabStickyChange', getStickyTabHeight);
        return () => {
            _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.off('tabStickyChange', getStickyTabHeight);
        };
    }, [_eventInstance]);
    //根据该tab是否吸顶改变tab吸顶高度
    useEffect(() => {
        if (!isStickyTab)
            return;
        //吸顶时文字tab高度44
        const height = tabStyle === TabStyle.TEXT ? 44 : getTabHeight();
        if (!height)
            return;
        let temp = stickyTabList === null || stickyTabList === void 0 ? void 0 : stickyTabList.find((i) => i.tabKey === _moduleId);
        if (isSticky && contentShow) {
            //吸顶时记录tab高度
            temp = temp || {
                tabKey: _moduleId,
                height: height,
                index: isSubTab ? (stickyTabList === null || stickyTabList === void 0 ? void 0 : stickyTabList.length) + 1 : 0
            };
            const tempTabStickyList = uniqBy([Object.assign(Object.assign({}, temp), { height: height }), ...stickyTabList], 'tabKey');
            _updateMaterialCustomGlobalVariables('stickyTabList', tempTabStickyList);
            _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.emit('tabStickyChange', {
                list: tempTabStickyList
            });
        }
        else if (temp) {
            //不吸顶时置0
            const tempTabStickyList = uniqBy([Object.assign(Object.assign({}, temp), { height: 0 }), ...stickyTabList], 'tabKey');
            _updateMaterialCustomGlobalVariables('stickyTabList', tempTabStickyList);
            _eventInstance === null || _eventInstance === void 0 ? void 0 : _eventInstance.emit('tabStickyChange', {
                list: tempTabStickyList
            });
        }
    }, [_eventInstance, isSticky, contentShow, stickyNavTopVal, stickyTabList]);
    //非画布渲染内容
    const [contentElements, setContentElements] = useState(() => {
        var _a;
        const _contentElements = (_a = new Array((tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) || 0)) === null || _a === void 0 ? void 0 : _a.fill({
            element: <></>,
            isLoading: true
        });
        if (children) {
            if (children.length > 1) {
                children.forEach((child, index) => {
                    _contentElements[index] = {
                        element: child,
                        isLoading: false
                    };
                });
            }
            else {
                _contentElements[activeIndex] = {
                    element: children[0] || children,
                    isLoading: false
                };
            }
        }
        return _contentElements;
    });
    // 获取数据
    const requestElement = (index, tabKey) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const res = yield getModuleDSL(tabKey);
        const newDsl = (_c = res === null || res === void 0 ? void 0 : res.DSL) === null || _c === void 0 ? void 0 : _c.componentsTree;
        if (newDsl && (newDsl === null || newDsl === void 0 ? void 0 : newDsl.length)) {
            setContentElements((preState) => {
                const _contentElements = [...preState];
                _contentElements[index] = {
                    element: _renderElement(newDsl[0]),
                    isLoading: false
                };
                return _contentElements;
            });
        }
    });
    const getTabHeight = useCallback(() => {
        const height = wrapperHeight.current;
        return height;
    }, [wrapperHeight.current]);
    // tab切换
    const onTabChange = (index, tabItem) => {
        var _a, _b;
        if (mcReport) {
            mcReport(mc_com_bid);
            mcReport(mc_bid, {
                valLab: {
                    tabName: tabItem.title,
                    moduleId: tabItem.tabKey,
                    activityId: tabItem.tabKey
                }
            });
        }
        if (activeIndex === index)
            return;
        if (isSticky) {
            const _stickyTopVal = (stickyTopVal || 0) - _toPx(topMarginVal);
            (_a = _uiInteractionAPI === null || _uiInteractionAPI === void 0 ? void 0 : _uiInteractionAPI.anchor) === null || _a === void 0 ? void 0 : _a.scrollToSticky({
                anchorKey: `${stickyAnchorId}${_moduleId}`,
                offset: _stickyTopVal
            });
        }
        // 如果当前没有渲染过的数据，Loading态
        if ((_b = contentElements[index]) === null || _b === void 0 ? void 0 : _b.isLoading) {
            setContentElements((preState) => {
                const _contentElements = [...preState];
                _contentElements[index] = {
                    element: <Loading _eventInstance={_eventInstance} loadingBgColorType={loadingBgColorType}/>,
                    isLoading: true
                };
                return _contentElements;
            });
            requestElement(index, tabItem.tabKey);
        }
        setActiveIndex(index);
        setSelectTabKey(tabItem.tabKey);
    };
    // 吸顶状态切换
    const onStateChange = debounce((hoverStatus) => {
        if (hoverStatus === 'hovering') {
            setIsSticky(true);
        }
        else {
            setIsSticky(false);
        }
    }, 100);
    const handleChangeVisible = () => {
        isTabVisible.current = true;
        if (!componentMvRef.current) {
            mvReport(mv_com_bid, {});
            componentMvRef.current = true;
        }
    };
    const onItemVisibleChange = (data) => {
        if (isTabVisible) {
            const { visibleItems } = data;
            visibleItems.forEach(index => {
                var _a;
                if (!((_a = tabItemsMVReportFlag.current) === null || _a === void 0 ? void 0 : _a[index])) {
                    mvReport(mv_bid, {
                        valLab: {
                            tabName: tabItems[index].title,
                            moduleId: tabItems[index].tabKey,
                            activityId: tabItems[index].tabKey
                        }
                    });
                }
                tabItemsMVReportFlag.current[index] = true;
            });
        }
    };
    // 渲染Tab头
    const renderTab = () => {
        //MCSectionsModule含副标题的文字tab吸顶时会触发动画，固定外层高度防止抖动
        // const isTextTab = tabStyle === TabStyle.TEXT && tabLevel === 1;
        // const tabBoxHeight = isTextTab && isDoubleLine && isStickyTab ? '54px' : undefined;
        return <View style={Object.assign(Object.assign({}, styles.tabBox), { opacity: tabContainerOpacity })}>
        <View style={styles.wrapperStyle}>
          <MaxSensor style={styles.innerWrapper} onAppear={handleChangeVisible} ref={wrapperRef} onLayout={onWrapperLayout}>
            {(tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) ? <Tab tabStyle={tabStyle} contentContainerStyle={styles.tabContainerStyle} tabTextType={tabLevel === 1 ? 'text' : 'tag'} activeIndex={activeIndex} onItemPress={onTabChange} isDoubleLine={isDoubleLine} data={tabItems} theme={theme} mode={mode} onItemVisibleChange={onItemVisibleChange} itemVisibleThreshold={100} tabWidth={tabWidth} isSticky={isSticky} isTabCenter={isTabCenter}/> : null}
          </MaxSensor>
          {(isExtraIconV || showExtraIcon && showMaskIcon) && renderExtraIcon()}
        </View>
        {isExtraIconV && renderTabExpand()}
      </View>;
    };
    const onWrapperLayout = (e) => {
        wrapperHeight.current = e.nativeEvent.layout.height || 0;
    };
    const onMRNContentLayout = (e) => {
        contentHeight.current = e.nativeEvent.layout.height || 0;
    };
    const onContentAppear = () => {
        setTabContainerOpacity(1);
    };
    const onContentDisappear = () => {
        setTabContainerOpacity(0);
    };
    // 渲染Tab内容
    const renderContent = () => {
        const renderRuntimeContent = () => {
            var _a;
            const _contentHeight = isWeb ? ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0 : contentHeight.current;
            const height = p2runit(_toPx(topMarginVal) + _toPx(bottomPaddingVal) + _contentHeight);
            const contentList = contentElements || [];
            return <MaxSensor visibleThreshold={1} checkVisibilityMode={'threshold'} onDisappear={onContentDisappear} onAppear={onContentAppear} style={_remStyle({
                    marginTop: bottomPaddingVal
                })}>
          <MaxSensor onDisappear={() => {
                    setContentShow(false);
                }} onAppear={() => {
                    setContentShow(true);
                }} style={{
                    position: 'absolute',
                    height: height
                }}/>
          <View style={{
                    flexDirection: 'row'
                }} ref={contentRef} mrnProps={{
                    onLayout: onMRNContentLayout
                }}>
            {contentList.map((contentElement, index) => {
                    //适配画布样式
                    if (isEdit && activeIndex !== index)
                        return;
                    return <View key={`${index}-tab`} className="commonTabBase" style={flattenStyle([activeIndex === index ? styles.show : styles.hide, {
                                flex: 1
                            }])}>
                  {contentElement.element}
                </View>;
                })}
          </View>
        </MaxSensor>;
        };
        return renderRuntimeContent();
    };
    //tab下拉按钮
    const renderExtraIcon = () => {
        const color = isSticky ? '#FFFFFF' : linerExtraColor;
        return <View className="commonTabiconWrapper" style={color ? styles.iconWrapper : styles.iconWrapperNoLiner} onClick={() => {
                var _a;
                if (fixedPosition === 'sticky' && !isSticky) {
                    const _topMarginVal = stickyTopVal - _toPx(topMarginVal || 0);
                    // -1避免顶部出现间隙
                    const _stickyTopVal = _topMarginVal - 1 || 0;
                    (_a = _uiInteractionAPI === null || _uiInteractionAPI === void 0 ? void 0 : _uiInteractionAPI.anchor) === null || _a === void 0 ? void 0 : _a.scrollToSticky({
                        anchorKey: `${stickyAnchorId}${_moduleId}`,
                        offset: _stickyTopVal
                        // animated: true
                    });
                    //等通用头部
                    setTimeout(() => {
                        setIsExtraTabOpen(true);
                    }, 500);
                }
                else {
                    setIsExtraTabOpen(true);
                }
            }}>
        {color && <LinearGradient colors={[`${color}00`, color]} start={{
                    x: 0,
                    y: 0
                }} end={{
                    x: 0.1,
                    y: 0
                }} style={Object.assign({}, styles.linearBox)} className="tabLinearGradient"></LinearGradient>}
        {isExtraIconV && <>
            <View style={styles.downIconBackground}></View>
            <LIcon uri={url.downIcon} type="body2" color="#222222" className="commonTabicon" style={_remStyle({
                    position: 'absolute',
                    width: 32,
                    height: 32,
                    right: isSticky ? 46 : 22,
                    top: '50%',
                    transform: isWeb ? `translateY(${_toPx(-16)}px)` : [{
                            translateY: _toPx(-16)
                        }]
                })}/>
          </>}
      </View>;
    };
    //tab下拉筛选框
    const renderTabExpand = () => {
        if (tabStyle === TabStyle.TEXT && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) < 5 || tabStyle === TabStyle.IMG && (tabItems === null || tabItems === void 0 ? void 0 : tabItems.length) < 6)
            return;
        return <TabExpand open={isExtraTabOpen} tabTextType={tabLevel === 2 ? 'tag' : 'text'} theme={theme} activeIndex={activeIndex} tabItems={tabItems} onTabChange={onTabChange} enableScroll={enableScroll} disableScroll={disableScroll} closeFloatingTab={() => {
                setIsExtraTabOpen(false);
            }} tabStyle={tabStyle}></TabExpand>;
    };
    if (isStickyTab) {
        const content = <>
        <MCSection hoverType={'autoHover'} hoverOffset={stickyTopVal} onHoverStatusChanged={({ hoverStatus }) => {
                hoverStatus && onStateChange(hoverStatus);
            }} backgroundColor={'transparent'}>
          {renderTab()}
        </MCSection>
        <MCSection backgroundColor={'transparent'}>{renderContent()}</MCSection>
      </>;
        return <>
        {!isSubTab ? <MCSectionsModule gapTop={_toPx(topMarginVal / 2)} gapBottom={_toPx(bottomMarginVal / 2)} ref={ref}>
            {content}
          </MCSectionsModule> : <View ref={ref}>{content}</View>}
      </>;
    }
    return <MCModule backgroundColor={'transparent'}>
      <View style={_remStyle({
            marginTop: topMarginVal,
            marginBottom: bottomMarginVal
        })}>
        {renderTab()}
        {renderContent()}
      </View>
    </MCModule>;
};
// const forwardComponent = forwardRef(TabContainer);
// forwardComponent.__isMCModule__ = true;
// export default forwardComponent;
export default TabContainer;
